<template>
  <div class="page-container">
    <reset-password></reset-password>
  </div>
</template>

<script>
import ResetPassword from './ResetPassword.vue'

export default {
  components: {
    ResetPassword
  }
}
</script>

<style scoped></style>
